export const isLocaleValid = (locale) => ['sr', 'en', 'sr-Cyrl'].includes(locale);
